// extracted by mini-css-extract-plugin
export default {"deleteSelected--content":"deleteSelected_deleteSelected--content__wmbtb","deleteSelected--content-btnContainer":"deleteSelected_deleteSelected--content-btnContainer__UeFeg"};